<template>
    <div>
        <!-- <b-button class="backButton" v-on:click="refreshUsersList()" disabled>Aktualizacja bazy danych</b-button> -->
        <!-- <b-button class="backButton" v-on:click="clearAllDatabase()" >Usuń całą bazę danych</b-button>
        <b-button class="backButton" v-on:click="actualizeDatabase()" >Aktualizacja bazy nowa</b-button>
        <b-button class="backButton" v-on:click="makeBackup()" >Przygotuj backup</b-button>
        <b-button class="backButton" v-on:click="runBackup()" >Wgraj backup</b-button> -->
        <b-button  v-if="userData.name === 'Maciej Kryczka'" class="backButton" v-on:click="actualization()" >AKTUALIZACJA BAZY</b-button>
        <!-- <b-button  v-if="userData.name === 'Maciej Kryczka'" class="backButton" v-on:click="sendMail()" >MAIL</b-button> -->

    </div>
</template>

<script>
import json from './Users.json';
import axios from 'axios';
import {path} from '../../config';
export default {
    name: 'UserList',
    props: ['userData'],
    methods: {
        async sendMail(){
            console.log('test maila')
            await axios
            .post(`${path}mails`, {email: 'maciej.kryczka@toya.com.pl', text: 'Przykładowy tekst alarmu'})
                .then(r => console.log(r))
                .catch(e => console.log(e));
        },
        async actualization(){
            console.log('AKTUALIZACJA')
            await this.makeBackup();
            await this.clearAllDatabase();
            await this.actualizeDatabase();
            await this.runBackup();
        },
        async actualizeDatabase(){
            let groupsDB = [];
            let usersDB = [];
            let usersWithGroups = [];
            for(let item of this.db){
                if(!groupsDB.includes(item.nazwa_grupy)){
                    const payload = {
                        name: item.nazwa_grupy,
                        author: 'admin'
                    }
                    if(item.nazwa_grupy !== 'VPN' && item.nazwa_grupy !== 'Andrzej Pasowski' && item.nazwa_grupy !== 'DTV CosmosNet' && item.nazwa_grupy !== 'Magdalena Strzałkowska' && item.nazwa_grupy !== 'Inni' && item.nazwa_grupy !== 'Zdzichu i kier'){
                        await axios
                            .post(`${path}groups`, payload)
                            .then(r => console.log(r.status))
                            .catch(e => console.log(e));
                    }
                    groupsDB.push(item.nazwa_grupy);
                }
            }
            for(let item of this.db){
                if(!usersDB.includes(`${item.imie} ${item.nazwisko}`)){
                    usersWithGroups.push({
                        firstName: item.imie,
                        lastName: item.nazwisko,
                        phoneNumber: (!item.telefon || item.telefon == "" || item.telefon == null) ? 0 : item.telefon,
                        mailAddress: item.email,
                        groups: [],
                        author: 'admin'
                        })
                    usersDB.push(`${item.imie} ${item.nazwisko}`);
                }
            }
            for(let item of this.db){
                for(let user of usersWithGroups){
                    if(item.imie === user.firstName && item.nazwisko === user.lastName){
                        if(item.nazwa_grupy !== 'VPN' && item.nazwa_grupy !== 'Andrzej Pasowski' && item.nazwa_grupy !== 'DTV CosmosNet' && item.nazwa_grupy !== 'Magdalena Strzałkowska' && item.nazwa_grupy !== 'Inni' && item.nazwa_grupy !== 'Zdzichu i kier'){
                            user.groups.push(item.nazwa_grupy)
                        }
                    }
                }
            }
            for(let item of usersWithGroups){
                await axios
                    .post(`${path}users`, item)
                    .then(r => console.log(r.status))
                    .catch(e => console.log(e));
            }
            groupsDB = [];

            console.log('koniec aktualizacji bazy');
        },
        async clearAllDatabase(){
            await axios
            .delete(`${path}groups`)
            .then(r => console.log(r.status))
            .catch(e => console.log(e));

            await axios
            .delete(`${path}users`)
            .then(r => console.log(r.status))
            .catch(e => console.log(e));

            console.log('koniec czyszczenia bazy');
        },
        async makeBackup (){
            let groups = [];
            let users = [];
            let backupGroups = [];
            // let backupUsers = [];
            await axios
                .get(`${path}groups`)
                .then(r => (
                console.log(r.status),
                groups = r.data
                ))
                .catch(e => console.log(e));
            for(let item of groups){
                if(item.author != 'admin'){
                    backupGroups.push(item)
                }
            }
            this.backupGroups = backupGroups;
            await axios
            .get(`${path}users`)
                .then(r => (
                console.log(r.status),
                users = r.data
                ))
                .catch(e => console.log(e));
            for(let item of backupGroups){
                for(let user of users){
                    if(user.groups.includes(item.name) && user.author === 'admin'){
                        await this.backupUsers.push(user);
                    }
                }
            }
            await axios
                .post(`${path}backup`, {backupUsers: this.backupUsers})
                .then(r => (
                    console.log(r.status)
                ))
                .catch(e => console.log(e));
            console.log('koniec przygotowania backupu');
        },
        async runBackup (){
                let users = []
                await axios
                    .get(`${path}users`)
                    .then(r => (
                    console.log(r.status),
                    users = r.data
                    ))
                    .catch(e => console.log(e));
                for(let item of users){
                    for(let user of this.backupUsers){
                        if(item.firstName === user.firstName && item.lastName === user.lastName)
                        await axios
                            .put(`${path}users/${item._id}`, user)
                            .then(r => console.log(r.status))
                            .catch(e => console.log(e));
                        
                    }
                }
            console.log('koniec wgrywania backupu');
        },


// STARY SKRYPT 
        refreshUsersGroups: async function(){
            await this.getGroups();
            await this.sendList();
            this.clearGroupsString();
            console.log('Zaktualizowano grupy');
            
        },
        refreshUsersList: async function(){
            await this.refreshUsersGroups();
            await this.getOldUsers();
            await this.prepareNewUsers();
            await this.connectUsers();
            await this.sendUsers();
            await this.updateUsers();
            this.clearGroupsString();
            console.log('Zaktualizowano użytkowników');
        },
        getOldUsers: async function(){
            await axios
            .get(`${path}users`)
            .then(response => (
                this.users = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            for(let user of this.users){
                let oldUser = {
                    imie: user.firstName,
                    nazwisko: user.lastName,
                    email: user.mailAddress,
                    telefon: user.phoneNumber,
                    tablica_grup: user.groups,
                    id: user._id,
                }
                this.oldUsersString.push(oldUser);
                this.oldUsersName.push(`${oldUser.imie} ${oldUser.nazwisko}`)
            }
        },
        prepareNewUsers: async function(){
            let usersString = [];
            let usersString2 = [];
            for(let item of this.db){
                if(!usersString.includes(`${item.imie} ${item.nazwisko}`)){
                usersString.push(`${item.imie} ${item.nazwisko}`)
                item.tablica_grup = [item.nazwa_grupy];
                item.telefon = Number(item.telefon);
                usersString2.push(item);
                } else {
                    for(let user of usersString2){
                        if(user.imie == item.imie && user.nazwisko == item.nazwisko && user != item){
                            if(user.tablica_grup != item.tablica_grup){
                                user.tablica_grup.push(item.nazwa_grupy);
                            }
                        }   
                    }  
                }
            }
            this.newUsersName = usersString;
            this.newUsersString = usersString2;
        },
        connectUsers: async function(){
            for(let user of this.newUsersString){
                if(!this.oldUsersName.includes(`${user.imie} ${user.nazwisko}`)){
                    await this.usersToPost.push(user);
                } else {
                    for(let userToCheck of this.oldUsersString){
                        if(userToCheck.imie == user.imie && userToCheck.nazwisko == user.nazwisko && userToCheck != user){
                            if(userToCheck.tablica_grup.toString() != user.tablica_grup.toString()){
                                userToCheck.tablica_grup = user.tablica_grup;
                                if(!this.usersToUpdate.includes(userToCheck)){
                                    await this.usersToUpdate.push(userToCheck);
                                }
                            }
                            if(userToCheck.telefon != user.telefon){
                                userToCheck.telefon = user.telefon;
                                if(!this.usersToUpdate.includes(userToCheck)){
                                    await this.usersToUpdate.push(userToCheck);
                                }
                            }
                            if(userToCheck.email != user.email){
                                userToCheck.email = user.email;
                                if(!this.usersToUpdate.includes(userToCheck)){
                                    await this.usersToUpdate.push(userToCheck);
                                }
                            }
                        }
                    }
                }
            }

            console.log('Users to Post: ', this.usersToPost, 'Users to Update: ', this.usersToUpdate);
        },

        sendUsers: async function(){
            let number = '';
            for(let item of this.usersToPost){
                if(!item.telefon || item.telefon == "" || item.telefon == null){
                    number = 0;
                }   else {
                    number = item.telefon;
                }
                let payload = {
                    firstName: item.imie,
                    lastName: item.nazwisko,
                    mailAddress: item.email,
                    phoneNumber: number,
                    groups: item.tablica_grup,
                }
                await axios
                    .post(`${path}users`, payload)
                    .then(r => console.log(r.status))
                    .catch(e => console.log(e));
            }
        },

        updateUsers: async function(){
            let number = ''
            for(let item of this.usersToUpdate){
                console.log('numer tell: ', item.telefon)
                if(!item.telefon || item.telefon == "" || item.telefon == null){
                    number = 0;
                }   else {
                    number = item.telefon;
                }
                let payload = {
                    firstName: item.imie,
                    lastName: item.nazwisko,
                    mailAddress: item.email,
                    phoneNumber: number,
                    groups: item.tablica_grup,
                }
                await axios
                    .put(`${path}users/${item.id}`, payload)
                    .then(r => console.log(r.status))
                    .catch(e => console.log(e));
            }
        },

        getGroups: async function(){
            this.groupsString = [];
            await axios
            .get(`${path}groups`)
            .then(response => (
                this.groups = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            for(let group of this.groups){
                this.groupsString.push(group.name)
            }
            return this.groupsString
        },
        sendList: async function(){
            let groupsString = [...this.groupsString];
            for(let item of this.db){
                if(!groupsString.includes(item.nazwa_grupy)){
                    const payload = {
                        name: item.nazwa_grupy,
                    } 
                    await axios
                        .post(`${path}groups`, payload)
                        .then(r => console.log(r.status))
                        .catch(e => console.log(e));
                    console.log('sent: ', item.nazwa_grupy)
                    groupsString.push(item.nazwa_grupy);
                }
            }
            groupsString = [];
        },
        clearGroupsString: function(){
            this.groupsString = [];
            this.usersString = [];
            this.usersName = [];
            this.oldUsersString = [];
            this.oldUsersName = [];
            this.newUsersName = [];
            this.newUsersString = [];
            this.usersToPost = [];
            this.usersToUpdate = [];
        }
    },
    data: function(){
        return{
            db: json,
            groups: '',
            groupsString: [],
            users: '',
            usersString: [],
            usersName: [],
            oldUsersString: [],
            oldUsersName: [],
            newUsersName: [],
            newUsersString: [],
            usersToPost: [],
            usersToUpdate: [],
            backupUsers: [],
            backupGroups: [],
        }
    }

}
</script>

<style lang="scss" scoped>
    .backButton {
        height: 50px;
        width: 90%;
        font-size: 20px;
        background-color: darkslategray;
        border-radius: 10px;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(40, 110, 214);
        }
        &:focus{
            background-color: blue;
            border: none;
            box-shadow: none;
        }
    }
</style>